import scrollLock from './scroll-lock'

class ToggleElement {
    constructor(element) {
        this.element = element
        this.target = element.getAttribute('data-target')
        this.classes = element.getAttribute('data-classes')
        this.siblingsClass = element.getAttribute('data-siblings')
        this.previousColor = '#c4c4ff';

        const targetDomEl = document.querySelector(this.target)

        this.scrollBehabviour = element.getAttribute('data-scroll')

        this.element.addEventListener('click', (event) => {
            let elementAriaExpanded = (this.element.getAttribute('aria-expanded') === 'true')

            event.preventDefault()

            const siblings = [].slice.call(document.querySelectorAll(this.siblingsClass))

            if ( elementAriaExpanded ) {
                siblings.forEach(item => item.setAttribute('aria-expanded', 'false'))
                scrollLock.disable()
                
            } else {
                siblings.forEach(item => item.setAttribute('aria-expanded', 'true'))
                scrollLock.enable()
            }

            targetDomEl.classList.toggle(this.classes)

        }, false)

    }
}

export default ToggleElement
